// extracted by mini-css-extract-plugin
export default {"background":"Weather_background__JXl5C","weatherList":"Weather_weatherList__PupGR","day":"Weather_day__d6mGo","icon":"Weather_icon__aU0Gw","dayInfo":"Weather_dayInfo__ZcHBZ"};